import { useQuery } from '@tanstack/react-query';

import { getFaculties } from 'api';
import { AxiosRequestConfig } from 'axios';

/**
 * A custom hook to fetch all faculties from the CoreService.
 *
 * @returns DefinedUseQueryResult<Faculty[], Error>
 */
export const useFacultiesQuery = (config?: AxiosRequestConfig) => {
  const query = useQuery({
    queryKey: ['faculties'],
    queryFn: () => {
      const faculties = getFaculties(config);
      return faculties;
    },
    initialData: []
  });
  return query;
};
